import useTranslation from '../utils/useTranslation';
import useHomeFloatingUi from '../hooks/useHomeFloatingUi';

export default function BackToTopButton() {
  const { t } = useTranslation();
  const visible = useHomeFloatingUi();

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      className={`back-to-top${visible ? ' is-visible' : ''}`}
      onClick={scrollTop}
      aria-label={t('footer_back_to_top')}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="18 15 12 9 6 15" />
      </svg>
    </button>
  );
}
